import styled from '@emotion/styled'
import { ApiDeposit, ApiLoan } from 'api/rtk-api'

import { Space, Typography } from '../../../components/core-v2'
import Icon from '../../../components/core-v2/atoms/Icon'
import LinkIcon from '../../../components/core-v2/molecules/linkIcon'
import CashInstrumentsView from '../templates/cash-instruments-view'

export type CashInstrumentsPanelProps = {
  canUserSave: boolean
  instruments: ApiDeposit[] | ApiLoan[]
  onSearch: (searchTerm: string) => void
  onSelectInstrument?: (assetId: string) => void
  onSelectNewInstrument: () => void
  selectedInstrument?: ApiDeposit | ApiLoan
}

const StyledInput = styled.input`
  width: 100%;
  padding: 12px;
  margin: 0;
  border: none;
  background: var(--White95);
  font-size: 15px;
  outline: none;
  font-weight: normal;
  color: var(--Graphite);
`

const StyledList = styled.div`
  border-top: solid 1px var(--White90);
  height: calc(100vh - 290px);
  overflow-y: auto;
`

export const CashInstrumentsPanel = ({
  canUserSave,
  instruments,
  onSearch,
  onSelectInstrument,
  onSelectNewInstrument,
  selectedInstrument
}: CashInstrumentsPanelProps) => (
  <Space isflex flexDirection="column">
    <Space mt={6}>
      <StyledInput type="text" onChange={e => onSearch(e.target.value)} />
    </Space>
    <Space isflex justifyContent="space-between" py={6}>
      <Typography fontSize="15px" fontWeight="800" letterSpacing="0px" variant="b3">
        {instruments.length} instruments found
      </Typography>
      {canUserSave && (
        <LinkIcon
          disabled={false}
          icon={<Icon name="circleAdd" size="default" />}
          iconPosition="left"
          text="Add a new instrument"
          onClick={() => onSelectNewInstrument()}
        />
      )}
    </Space>
    <StyledList>
      <CashInstrumentsView
        instruments={instruments}
        selectedInstrument={selectedInstrument}
        onSelectInstrument={onSelectInstrument}
      />
    </StyledList>
  </Space>
)
